import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Stack } from "@mui/system";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Answer from "./Answer";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const QuestionCard = ({ question, setQ, isSearchedData }) => {
  const navigate = useNavigate();
  const [answerToSubmit, setAnswerToSubmit] = useState("");
  const [error, setError] = useState("");
  const [answers, setAnswers] = useState([]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [isDisliked, setIsDisliked] = useState(false);
  const [dislikeCount, setDislikeCount] = useState(0);
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    question?.user &&
      api
        .get(`/user/getUserdataById/` + question?.user?.id)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [question]);

  useEffect(() => {
    api
      .get(`/questions/answers-of-particular-question/${question._id}`)
      .then((res) => {
        console.log("superrrrrrrrrrr question id", question?._id);
        console.log("answers", res.data);
        setAnswers(res.data);
      })
      .catch((err) => console.log(err));
  }, [question]);
  const deleteQuestion = (q) => {
    console.log(q);
    api
      .delete(`/questions/${q?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your question for violating terms and conditions.`,
            forAll: false,
            receiverId: q?.user.id,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  useEffect(() => {
    // console.log("question", question);
    let temp = false;
    question?.likerIds?.map((id) => {
      if (id == currentUser?.id) {
        temp = true;
      }
    });
    setIsLiked(temp);
    setLikeCount(
      question?.likerIds?.length > 0 ? question?.likerIds?.length : 0
    );
    /******** */
    let temp2 = false;
    question?.dislikerIds?.map((id) => {
      if (id == currentUser?.id) {
        temp2 = true;
      }
    });
    setIsDisliked(temp2);
    setDislikeCount(
      question?.dislikerIds?.length > 0 ? question?.dislikerIds?.length : 0
    );
  }, [question]);
  /********* */
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const submitAnswer = (e) => {
    e.preventDefault();
    setAnswerToSubmit("");
    if (!answerToSubmit) {
      setError("required");
    }
    //  else if (answer.length < 50) {
    //   setError("your answer should be 50 chrachters long atleast.");
    // }
    else {
      console.log("question", question);
      console.log("answer", answerToSubmit);
      const body = {
        userId: currentUser.id,
        user: currentUser,
        questionId: question?._id ? question?._id : question?.id,
        question: question,
        answer: answerToSubmit,
      };
      api
        .post("/questions/answer", body)
        .then((res) => {
          if (res.data) {
            let notifBody = {
              userId: currentUser?.id,
              text: `${currentUser?.name} answers your question.`,
              forAll: false,
              receiverId: question?.userId,
            };
            api
              .post("/notifications", notifBody)
              .then((re) => console.log("notif", re.data));
            // window.location.reload();
            setAnswers([...answers, res.data]);
          }
        })
        .catch((err) => setError("unable to submit"));
    }
  };
  const likeQuestion = () => {
    if (isDisliked) {
      setIsDisliked(false);
      let x = dislikeCount - 1;
      setDislikeCount(x);
      dislikeQuestionUndo();
    }
    setIsLiked(true);
    let x = likeCount + 1;
    setLikeCount(x);

    api
      .post(
        `/questions/like-question/${
          question?.id ? question?.id : question?._id
        }/${currentUser?.id}`
      )
      .then((res) => {
        console.log("response data of like question", res?.data);
        let notifBody = {
          userId: currentUser?.id,
          text: `${currentUser?.name} liked your question.`,
          forAll: false,
          receiverId: question?.userId,
        };
        api
          .post("/notifications", notifBody)
          .then((re) => console.log("notif", re.data));
      })
      .catch((err) => console.log("error while liking question", err));
  };
  const likeQuestionUndo = () => {
    setIsLiked(false);
    let x = likeCount - 1;
    setLikeCount(x);
    api
      .post(
        `/questions/like-question-undo/${
          question?.id ? question?.id : question?._id
        }/${currentUser?.id}`
      )
      .then((res) => {
        console.log("response data of undo like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };

  const dislikeQuestion = () => {
    if (isLiked) {
      setIsLiked(false);
      let x = likeCount - 1;
      setLikeCount(x);
      likeQuestionUndo();
    }
    setIsDisliked(true);
    let x = dislikeCount + 1;
    setDislikeCount(x);

    api
      .post(
        `/questions/dislike-question/${
          question?.id ? question?.id : question?._id
        }/${currentUser?.id}`
      )
      .then((res) => {
        console.log("response data of like question", res?.data);
        let notifBody = {
          userId: currentUser?.id,
          text: `${currentUser?.name} disliked your question.`,
          forAll: false,
          receiverId: question?.userId,
        };
        api
          .post("/notifications", notifBody)
          .then((re) => console.log("notif", re.data));
      })
      .catch((err) => console.log("error while liking question", err));
  };
  const dislikeQuestionUndo = () => {
    setIsDisliked(false);
    let x = dislikeCount - 1;
    setDislikeCount(x);
    api
      .post(
        `/questions/dislike-question-undo/${
          question?.id ? question?.id : question?._id
        }/${currentUser?.id}`
      )
      .then((res) => {
        console.log("response data of undo like question", res?.data);
      })
      .catch((err) => console.log("error while liking question", err));
  };
  return (
    <Card sx={{ width: "100%", marginTop: "20px" }}>
      <CardHeader
        onClick={() => navigate(`/user-profile/${question?.userId}`)}
        className="title__link"
        avatar={
          <Stack direction="column">
            {uploader?.profile ? (
              <Avatar src={uploader?.profile} />
            ) : (
              <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                {question?.user?.name?.at(0)?.toUpperCase()}
              </Avatar>
            )}
          </Stack>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        title={question?.user?.name?.toUpperCase()}
        subheader={new Date(question?.createdAt).toDateString()}
      />

      <CardContent>
        <Typography
          sx={{ fontSize: "1.2rem", marginBottom: "10px", fontWeight: "500" }}
          color="fontPrimaryColor.main"
          className="question__title title__link"
          onClick={() => navigate(`/answers/${question._id}`)}
        >
          {question?.question}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {question?.description}
        </Typography>
        <Box className="language mt-4 bg-white">
          <Box className="tags bg-white">
            {question?.tags?.map((t) => (
              <Typography className="tag-span">{t}</Typography>
            ))}
          </Box>
        </Box>
      </CardContent>
      {question?.image && (
        <CardMedia
          component="img"
          height="194"
          image={question?.image}
          alt="Paella dish"
          sx={{ backgroundColor: "whitesmoke" }}
        />
      )}

      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
        <Stack direction="column" sx={{ width: "50px", alignItems: "center" }}>
          {isLiked ? (
            <IconButton onClick={() => likeQuestionUndo()}>
              <ThumbUpIcon />
            </IconButton>
          ) : (
            <IconButton onClick={() => likeQuestion()}>
              <ThumbUpOutlinedIcon />
            </IconButton>
          )}

          <Typography sx={{ fontSize: "10px" }}>{likeCount}</Typography>
        </Stack>
        <Stack direction="column" sx={{ width: "50px", alignItems: "center" }}>
          {isDisliked ? (
            <IconButton onClick={() => dislikeQuestionUndo()}>
              <ThumbDownIcon />
            </IconButton>
          ) : (
            <IconButton onClick={() => dislikeQuestion()}>
              <ThumbDownOffAltOutlinedIcon />
            </IconButton>
          )}

          <Typography sx={{ fontSize: "10px" }}>{dislikeCount}</Typography>
        </Stack>
        <Stack
          direction="column"
          sx={{
            width: "80px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <IconButton onClick={handleExpandClick}>
            <QuestionAnswerOutlinedIcon />
          </IconButton>
          {/* <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <QuestionAnswerOutlinedIcon />
          </ExpandMore> */}
          <Typography sx={{ fontSize: "10px" }}>
            {answers?.length} answers
          </Typography>
        </Stack>

        {window.location.pathname == "/my-questions" ? (
          <>
            {" "}
            <div className="  mt-3 mb-3 flex-box justify-left ml-auto">
              <button
                onClick={() => navigate(`/edit-question/${question?._id}`)}
                className="asc__submit__form__button mr-2"
              >
                Edit Question
              </button>
            </div>
            <button
              className=" asc__submit__form__button mr-2"
              onClick={() => deleteQuestion(question)}
            >
              Delete Question
            </button>
          </>
        ) : (
          <>
            {currentUser?.isAdmin ? (
              <button
                className="  col-12 mr-auto mt-3 mb-3 asc__submit__form__button"
                onClick={() => deleteQuestion(question)}
                sx={{ marginLeft: "30px" }}
              >
                Delete Question
              </button>
            ) : (
              <></>
              // <Button
              //   sx={{
              //     marginLeft: "auto",
              //     marginRight: "15px",
              //     backgroundColor: "colorTwo.main",
              //     fontSize: "0.8rem",
              //   }}
              //   variant="contained"
              //   className="answers-status-btn  answer-btn"
              //   data-bs-toggle="modal"
              //   data-bs-target="#exampleModal"
              //   onClick={() => setQ(question)}
              // >
              //   Answer
              // </Button>
            )}
          </>
        )}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          {" "}
          <Stack direction="row" sx={{ gap: "3px" }}>
            {currentUser?.profile ? (
              <Avatar src={currentUser?.profile} />
            ) : (
              <Avatar>{currentUser?.name[0]}</Avatar>
            )}
            <input
              type="text"
              style={{ flex: "1" }}
              className="submit__ans__input__field"
              placeholder="write your answer here..."
              onChange={(e) => setAnswerToSubmit(e.target.value)}
              value={answerToSubmit}
            ></input>
            <button
              className="asc__submit__form__button ans"
              onClick={(e) => submitAnswer(e)}
            >
              Add Comment
            </button>
          </Stack>
          <Box className="mt-5">
            <Typography sx={{ fontSize: "1.2rem", fontWeight: "500" }}>
              Answers
            </Typography>
            <div className="answer__container">
              {answers.length > 0 ? (
                answers
                  ?.sort(function (a, b) {
                    return new Date(b.updatedAt) - new Date(a.updatedAt);
                  })
                  ?.filter((a, i) => i < 2)
                  ?.map((ans) => (
                    // <div className="ans">
                    //   <h1>{ans.user.name}</h1>
                    //   <p>{ans.answer}</p>
                    // </div>
                    <Answer ans={ans} />
                  ))
              ) : (
                <Typography variant="body2" className="mt-2">
                  no answers
                </Typography>
              )}
              <button
                className="asc__submit__form__button"
                onClick={() => navigate(`/all-answers/${question?._id}`)}
              >
                See All Answers
              </button>
            </div>
            {/* answer */}
          </Box>
        </CardContent>
      </Collapse>
    </Card>
    //     <div className="row pt-3 mb-3 border-bottom border-dark pb-3 question__container">
    //       <div className="col-lg-6 col-md-6 col-12">
    //         <h6 className="post-name">
    //           <strong>{question?.user?.name}</strong>
    //         </h6>
    //       </div>
    //       <div className="col-lg-6 col-md-6 col-12">
    //         <h6 className="post-date">
    //           Posted:{" "}
    //           <strong>{new Date(question?.createdAt).toDateString()}</strong>
    //         </h6>
    //       </div>
    //       <div className="col-12">
    //         <h6 className="question">{question?.question}</h6>
    //       </div>
    //       <div className="col-12">{/* <img src={questionImage}/> */}</div>
    //       <div className="col-12">
    //         <p className="description">{question?.description}</p>
    //       </div>
    //       <div className="language">
    //         <div className="tags">
    //           {question?.tags.map((t) => (
    //             <span className="tag-span">{t}</span>
    //           ))}
    //         </div>
    //       </div>
    //       {currentUser?.isAdmin ? (
    //         <button
    //           className=" btn-link col-6 mr-auto mt-3 mb-3"
    //           onClick={() => deleteQuestion(question)}
    //         >
    //           Delete Question
    //         </button>
    //       ) : (
    //         <div className="answer row m-0 mt-3">
    //           {currentUser?.id !== question.userId && (
    //             <>
    //               {!isSearchedData && (
    //                 <div className="col-6 answer-status">
    //                   {/* modal is in the feedback component */}
    //                   <button
    //                     className="answers-status-btn  answer-btn"
    //                     data-bs-toggle="modal"
    //                     data-bs-target="#exampleModal"
    //                     onClick={() => setQ(question)}
    //                   >
    //                     <span className="fa fa-comment"></span> Answer
    //                   </button>
    //                 </div>
    //               )}
    //             </>
    //           )}
    //           <div
    //             className={currentUser?.id == question.userId ? "col-12" : "col-6"}
    //           >
    //             <Link
    //               className="float-right answer-btn"
    //               to={`/newsfeed/answers/${question._id}`}
    //             >
    //               {answers.length} Answer
    //             </Link>
    //           </div>
    //         </div>
    //       )}

    //       {window.location.pathname == "/newsfeed/usernewsfeed" && (
    //         <>
    //           {" "}
    //           <div className="col-1  mt-3 mb-3 flex-box justify-left">
    //             <Link
    //               to={`/askquestion/edit/${question?._id}`}
    //               className="btn btn-link  mr-6"
    //             >
    //               Edit
    //             </Link>
    //           </div>
    //           <button
    //             className=" btn-link col-6 mr-auto mt-3 mb-3"
    //             onClick={() => deleteQuestion(question)}
    //           >
    //             Delete Question
    //           </button>
    //         </>
    //       )}
    //     </div>
  );
};

export default QuestionCard;
